import { render } from "./GivingForm.vue?vue&type=template&id=234c22ed&scoped=true"
import script from "./GivingForm.vue?vue&type=script&lang=js"
export * from "./GivingForm.vue?vue&type=script&lang=js"

import "./GivingForm.vue?vue&type=style&index=0&id=234c22ed&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-234c22ed"]])

export default __exports__